export const DETAILED_QUERY_PARAM = { projection: 'detailed' }
export const SIMPLE_QUERY_PARAM = { projection: 'simple' }
export const TREE_QUERY_PARAM = { projection: 'tree' }
export const WITH_ANSWERS_QUERY_PARAM = { projection: 'withAnswersList' }
export const DASHBOARD_QUERY_PARAM = { projection: 'dashboard' }
export const LIST_QUERY_PARAM = { projection: 'list' }
export const CAREGIVER_PARAM = { projection: 'careGiverPatients' }
export const TELEMEDICINE_LOG_PARAM = { projection: 'report' }
export const TELEMEDICINE_LOG_EXPORT_PARAM = { projection: 'exportReport' }
export const TELEMEDICINE_APPOINTMENT_PARAM = { projection: 'appointment' }
export const TELEMEDICINE_APPOINTMENT_EXPORT_PARAM = {
  projection: 'exportAppointment'
}
export const GROUPED_QUERY_PARAM = {
  projection: 'grouped'
}
export const CALLS_QUERY_PARAM = {
  projection: 'calls'
}
export const WAITING_QUERY_PARAM = {
  projection: 'waiting'
}
export const DURATION_QUERY_PARAM = {
  projection: 'duration'
}
export const UUID_QUERY_PARAM = {
  projection: 'uuid'
}
